import EndInertiaUtil from './EndInertiaUtil.js';
export default function MouseWheelInertiaUtil({ endTimeRange = 200, xDecelerationPerSecond = Infinity, yDecelerationPerSecond = Infinity, xMaxSpeed = Infinity, yMaxSpeed = Infinity, mouseWheelInertiaScale: scale, } = {}) {
    let timeout = -1;
    const eiu = EndInertiaUtil(endTimeRange, xDecelerationPerSecond, yDecelerationPerSecond, xMaxSpeed, yMaxSpeed, scale);
    const push = eiu.push.bind(eiu);
    const stop = eiu.stop.bind(eiu);
    const end = eiu.end.bind(eiu);
    return Object.assign(eiu, {
        push(x, y) {
            push(x * scale, y * scale);
            if (timeout !== -1)
                cancelAnimationFrame(timeout);
            timeout = requestAnimationFrame(end);
        },
        stop() {
            if (eiu.isRunning())
                stop();
            if (timeout !== -1) {
                cancelAnimationFrame(timeout);
                timeout = -1;
            }
        },
    });
}
;
//# sourceMappingURL=MouseWheelInertiaUtil.js.map